export default "__VITE_ASSET__DFcNrqoS__"